























































































































































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";

import ListMailAddresses from "../general/ListMailAddresses.vue";

import WorkshopsBookingDetails from "../workshops/WorkshopsBookingDetails.vue";
import WorkshopJson from "../../shared/WorkshopJson";
import WorkshopBookingJson from "../../shared/WorkshopBookingJson";
import { WorkshopWithBookingsJson } from "../../shared/WorkshopJson";
import { WorkshopWithBookingJson } from "../../shared/WorkshopJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

import GeneralInfos from "../custom/GeneralInfos";

export default Vue.extend({
  name: "WorkshopsParticipants",
  components: {
    Loading,
    TableView,
    ListMailAddresses,
    WorkshopsBookingDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
    WorkshopsBookingStatusNames: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      GeneralInfos: GeneralInfos,
      showMailAddressesList: false,
      bookedMailAddressesList: [] as string[],
      showDetails: false,
      detailsMode: "read",
      allWorkshops: null as WorkshopJson[] | null,
      selectedWorkshopWithBookings: null as WorkshopWithBookingsJson | null,
      selectedWorkshopId: null as number | null,
      selectedWorkshopBookingId: null as number | null,
      showOldWorkshops: false as boolean,
      loadingConfirmation: false as boolean,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.reloadData();
      }
    },

    openDetails(item: WorkshopWithBookingJson | null, mode: string) {
      if (this.selectedWorkshopId != null) {
        if (item != null) {
          this.selectedWorkshopBookingId = item.ID;
        } else {
          this.selectedWorkshopBookingId = null;
        }

        this.detailsMode = mode;
        this.toggleDetails();
      } else {
        alert("Es muss zuerst ein Programm ausgewählt werden.");
      }
    },
    /*** END: details view ***/

    loadData() {
      this.loadAllWorkshops();
    },

    async loadAllWorkshops() {
      this.allWorkshops = null;
      this.selectedWorkshopId = null;
      this.selectedWorkshopBookingId = null;
      this.selectedWorkshopWithBookings = null;

      if (this.restClient != null) {
        try {
          this.allWorkshops = await this.restClient.getWorkshops();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadSelectedWorkshopWithBookings() {
      if (this.allWorkshops != null) {
        this.selectedWorkshopWithBookings = null;

        if (this.restClient != null && this.selectedWorkshopId != null) {
          try {
            this.selectedWorkshopWithBookings = await this.restClient.getWorkshopWithBookings(this.selectedWorkshopId);
          } catch (e) {
            alert(e.message);
          }
        }
      }
    },

    async sendBookingConfirmation(bookingId: number) {
      if (this.selectedWorkshopId != null && bookingId != null && this.restClient != null) {
        this.loadingConfirmation = true;

        try {
          await this.restClient.confirmWorkshopBooking(this.selectedWorkshopId, bookingId);
          alert("Die Anfrage wurde gebucht und es wurde eine Bestätigung an den Kunden gesendet.");
          this.loadingConfirmation = false;
          this.loadSelectedWorkshopWithBookings();
        } catch (e) {
          this.loadingConfirmation = false;
          alert(e.message);
        }
      }
    },

    //print list
    printSelectedWorkshopBookingsList() {
      var toPrint = document.getElementById("toPrint");

      if (toPrint != null) {
        var eles = this.$el.querySelectorAll(".print-view");

        for (let i = 0; i < eles.length; i++) {
          toPrint.appendChild(eles[i].cloneNode(true));
        }
      }

      this.$nextTick(() => {
        window.print();
      });

      this.$nextTick(() => {
        while (toPrint?.lastElementChild) {
          toPrint.removeChild(toPrint.lastElementChild);
        }
      });
    },

    sendMailToBooked() {
      if (this.bookedWorkshopBookings != null) {
        this.bookedMailAddressesList = [];
        var mailtoString = "mailto:" + GeneralInfos.email;

        mailtoString += "?bcc=";

        for (let i = 0; i < this.bookedWorkshopBookings.length; i++) {
          let mailAddress = this.bookedWorkshopBookings[i].customer.email;

          if (!this.bookedMailAddressesList.includes(mailAddress)) {
            this.bookedMailAddressesList.push(mailAddress);
          }
        }

        mailtoString += this.bookedMailAddressesList.join(";");

        if (mailtoString.length < 2048) {
          window.location.href = mailtoString;
          //window.open(mailtoString, "_blank")
        } else {
          alert(
            "Die E-Mail Vorlage an alle Teilnehmenden konnte leider nicht automatisch erstellt werden. Im folgenden werden die E-Mail Adressen zum kopieren angezeigt."
          );
          this.showMailAddressesList = true;
        }
      }
    },

    async reloadData() {
      this.loadSelectedWorkshopWithBookings();
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }

      if (button == "sendBookingConfirmation") {
        this.sendBookingConfirmation(item.ID);
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.reloadData();
      }
    },
  },
  computed: {
    permissionAbleManagement: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    filteredWorkshops(): WorkshopJson[] | null {
      if (this.allWorkshops != null && !this.showOldWorkshops) {
        let today = new Date();
        let filtered = this.allWorkshops.filter((i: any) => new Date(i.dates[i.dates.length - 1].endDateTime) > today);

        return filtered;
      } else {
        return this.allWorkshops;
      }
    },

    workshopColumns: function (): TableViewColumnDefinitions<WorkshopBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Name (Erziehungsberechtigte:r)",
          td: (i) =>
            i.customer.guardianLastName != ""
              ? i.customer.guardianLastName + ", " + i.customer.guardianFirstName
              : "--",
        },
        {
          th: "Name (Teilnehmende:r)",
          td: (i) =>
            i.customer.childLastName != "" ? i.customer.childLastName + ", " + i.customer.childFirstName : "--",
        },
        {
          th: "Angefragt",
          td: (i) => DateFormatter.formatDateTime(new Date(i.bookingDateTime)),
        },
        {
          th: "Status",
          td: (i) => vue.WorkshopsBookingStatusNames[i.state],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<WorkshopBookingJson>[];
    },

    workshopWaitinglistColumns: function (): TableViewColumnDefinitions<WorkshopBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Name (Erziehungsberechtigte:r)",
          td: (i) =>
            i.customer.guardianLastName != ""
              ? i.customer.guardianLastName + ", " + i.customer.guardianFirstName
              : "--",
        },
        {
          th: "Name (Teilnehmende:r)",
          td: (i) =>
            i.customer.childLastName != "" ? i.customer.childLastName + ", " + i.customer.childFirstName : "--",
        },
        {
          th: "Angefragt",
          td: (i) => DateFormatter.formatDateTime(new Date(i.bookingDateTime)),
        },
        {
          th: "Status",
          td: (i) => vue.WorkshopsBookingStatusNames[i.state],
        },
        {
          th: "",
          td: (i) => "Aufrücken und benachrichtigen",
          style: (i) => "text-align:right",
          button: "sendBookingConfirmation",
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<WorkshopBookingJson>[];
    },

    requestedWorkshopBookings(): WorkshopBookingJson[] | null | undefined {
      if (this.selectedWorkshopWithBookings != null) {
        var states = ["requested"];
        let requestedWorkshopBookings = this.selectedWorkshopWithBookings.bookings.filter((i) =>
          states.includes(i.state)
        );
        return requestedWorkshopBookings;
      }
    },

    bookedWorkshopBookings(): WorkshopBookingJson[] | null | undefined {
      if (this.selectedWorkshopWithBookings != null) {
        var states = [
          "bookedReadyForDepositPayment",
          "bookedDepositPaymentExported",
          "readyForPayment",
          "paymentExported",
        ];
        let requestedWorkshopBookings = this.selectedWorkshopWithBookings.bookings.filter((i) =>
          states.includes(i.state)
        );
        return requestedWorkshopBookings;
      }
    },

    waitingListWorkshopBookings(): WorkshopBookingJson[] | null | undefined {
      if (this.selectedWorkshopWithBookings != null) {
        var states = ["waitingList"];
        let requestedWorkshopBookings = this.selectedWorkshopWithBookings.bookings.filter((i) =>
          states.includes(i.state)
        );
        return requestedWorkshopBookings;
      }
    },

    selectedWorkshopRegistrationsLeftText(): string {
      if (this.selectedWorkshopWithBookings != null) {
        const maxRegistrationCount = this.selectedWorkshopWithBookings.registrationMaximumCount;
        let registrationCount = 0;

        for (let i = 0; i < this.selectedWorkshopWithBookings.bookings.length; i++) {
          if (
            this.selectedWorkshopWithBookings.bookings[i].state != "requested" &&
            this.selectedWorkshopWithBookings.bookings[i].state != "canceled" &&
            this.selectedWorkshopWithBookings.bookings[i].state != "cancellationFeeExported" &&
            this.selectedWorkshopWithBookings.bookings[i].state != "waitingList"
          ) {
            registrationCount++;
          }
        }

        if (maxRegistrationCount === undefined) {
          return "Freie Plätze: [Fehler]";
        }

        let registrationsLeft = maxRegistrationCount - registrationCount;

        if (registrationsLeft < 0) {
          return "Bereits überbucht";
        } else if (registrationsLeft == 1) {
          return "Noch 1 freier Platz";
        } else {
          return "Noch " + registrationsLeft + " freie Plätze";
        }
      }

      return "Lade freie Plätze...";
    },

    selectedWorkshopWaitingListLeftText(): string {
      if (this.selectedWorkshopWithBookings != null) {
        const maxWaitingListCount = this.selectedWorkshopWithBookings.waitingListMaximumCount;
        let waitingListCount = 0;

        for (let i = 0; i < this.selectedWorkshopWithBookings.bookings.length; i++) {
          if (this.selectedWorkshopWithBookings.bookings[i].state == "waitingList") {
            waitingListCount++;
          }
        }

        if (maxWaitingListCount === undefined) {
          return "Warteliste: [Fehler]";
        }

        let waitingListLeft = maxWaitingListCount - waitingListCount;

        if (waitingListLeft < 0) {
          return "Warteliste: Überbucht";
        } else if (waitingListLeft == 1) {
          return "Warteliste: 1 Platz frei";
        } else {
          return "Warteliste: " + waitingListLeft + " Plätze frei";
        }
      }

      return "Lade Warteliste...";
    },

    sortedBookedWorkshopBookingsByChildLastName(): object[] | null | undefined {
      if (this.bookedWorkshopBookings != null) {
        var customers = [];

        for (let i = 0; i < this.bookedWorkshopBookings.length; i++) {
          var newObj: any = {};

          let k = this.bookedWorkshopBookings[i].customer;
          let index: keyof typeof k;

          for (index in this.bookedWorkshopBookings[i].customer) {
            newObj[index] = this.bookedWorkshopBookings[i].customer[index];
          }

          customers.push(newObj);
        }

        customers.sort(function (a, b) {
          let nameA = a.childLastName.toLowerCase();
          let nameB = b.childLastName.toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });

        return customers;
      }
    },
  },
});
